import { render } from "./CompleteCase.vue?vue&type=template&id=d631b8fa&scoped=true"
import script from "./CompleteCase.vue?vue&type=script&lang=js"
export * from "./CompleteCase.vue?vue&type=script&lang=js"

import "./CompleteCase.vue?vue&type=style&index=0&id=d631b8fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d631b8fa"]])

export default __exports__